import { Avatar, Stack } from "@mui/material";
import React from "react";
import { seeds } from "utils/avatars";
import LabelledOutline from "components/react-lib/generic-ui/LabelledOutline";
import { COLORS } from "colors";
import { useTheme } from "@emotion/react";


export function AvatarButton({ seed, selected, onClick }) {

  const theme = useTheme();

  const handleClick = () => {
    if (onClick) {
      onClick(seed);
    }
  };

  return (
    <Avatar
      data-testclass="avatar-button"
      onClick={handleClick}
      src={`https://api.dicebear.com/7.x/bottts/svg?seed=${seed}`}
      sx={{
        padding: "3px",
        border: selected ? `2px dotted ${theme.palette.secondary.main}` : "2px solid rgba(0, 0, 0, 0)",
      }}
    />
  );
}

export default function AvatarSelector({ avatar, setAvatar }) {

  const theme = useTheme();

  return (
    <LabelledOutline 
      label="Avatar"
      rawLabelColor={theme.palette.formLabel.main}
    >
      <Stack
        direction="row"
        flexWrap="wrap"
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        {seeds.map((seed) => (
          <AvatarButton
            key={seed}
            seed={seed}
            selected={seed === avatar}
            onClick={(seed) => setAvatar(seed)}
          />
        ))}
      </Stack>
    </LabelledOutline>
  );
}
